import { useCallback } from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/20/solid';
import { Button } from '../../_core/button/button.component';
import { useDownloadAsset } from './asset.service';
import { UploadItemData } from '../../_editor/upload/upload.types';
import { IRequestTokenParams } from '../../../lib/types';
import { getDownloadFileName } from './download-utils';

interface IDownloadAssetButtonProps extends UploadItemData, IRequestTokenParams {
  baseActiveSection?: number | null;
  getLatestFileLabel: (_: string) => string | null;
  tag?: string;
}

export const DownloadAssetButton = ({
  baseActiveSection,
  getLatestFileLabel,
  requestToken,
  tag,
  ...itemData
}: IDownloadAssetButtonProps) => {
  const { downloadAsset } = useDownloadAsset(itemData, requestToken);

  const handleDownload = useCallback(() => {
    const fileName = getDownloadFileName({ baseActiveSection, getLatestFileLabel, itemData, tag });
    downloadAsset(fileName);
  }, [baseActiveSection, downloadAsset, getLatestFileLabel, itemData, tag]);

  return (
    <Button
      hideEndMargin
      icon={<ArrowDownTrayIcon height={20} width={20} />}
      variant="secondary"
      onClick={handleDownload}
    />
  );
};
